import BaseEnum from "./base_enum.js";

class DearEnumDesc extends BaseEnum {

  name() {
    return "dear";
  }

  rawValues() {
    return ["herr", "frau"];
  }

}

const DearEnum = new DearEnumDesc();
export default DearEnum;